import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/button';
import { Input } from '@components/ui/form/input';
import { ActionSheet } from '@components/scheduling/actionSheet';
import { ExternalDoneSheetProps } from './types';

export const ExternalDoneSheet = ({
  open,
  onDismiss,
  options,
  initialValues,
  disabled,
  onConfirm,
}: ExternalDoneSheetProps) => {
  const { t } = useTranslation('app');
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    setValues(initialValues);
  }, [initialValues]);

  return (
    <ActionSheet
      open={open}
      onDismiss={onDismiss}
      title={t('scheduling.external.doneTitle')}
      description={t('scheduling.external.doneInfo')}
      actions={
        <div>
          <Button variant="secondary" onClick={onDismiss}>
            {t('actions.cancel')}
          </Button>
          <Button disabled={disabled} onClick={() => onConfirm(values)}>
            {t('actions.markAsDone')}
          </Button>
        </div>
      }>
      <div className="grid grid-cols-2 gap-x-4 gap-y-3 pb-1 pr-3 [&_.h-8]:h-11">
        {options.map((option) => {
          const id = option.id || '';
          const isNumber = option.valueType === 'number';

          return (
            <label key={id} className="flex min-w-0 flex-col gap-1">
              <span className="truncate text-sm text-neutral-600">
                {option.includeEstimated
                  ? t('forms.finalUnits.label', { name: option.name, unit: option.unit || '' })
                  : `${option.name} ${option.unit || ''}`.trim()}
              </span>
              <Input
                type={isNumber ? 'number' : 'text'}
                inputMode={isNumber ? 'decimal' : undefined}
                rightAlignValue={isNumber && Boolean(option.unit)}
                suffixElement={<span>{option.unit}</span>}
                value={values[id] || ''}
                onChange={(e) => setValues((prev) => ({ ...prev, [id]: e.target.value }))}
              />
            </label>
          );
        })}
      </div>
    </ActionSheet>
  );
};
